export default "__VITE_ASSET__DUm60URU__"